// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fcf5fc8a","453":"e4dfcb09","455":"3f7f2f7e","977":"a5c863ab"}[chunkId] + ".chunk.js";
};